import { call, put, takeLatest } from "@redux-saga/core/effects";
import { errorBirthdayWishes, errorEventsAction, errorEventsNotificationsAction, errorWorkAnniversaryWishes, EVENT_ACTION, responseBirthdayWishes, responseEventsAction, responseEventsNotificationsAction, responseWorkAnniversaryWishes } from "./EventActionCreator";
import EventService from "../../Services/RestApiManager/EventManager/EventService";

export function* eventsListRequest(action) {
    try {
        const response = yield call(EventService.shared.eventsListRequest, action.data);
        yield put(responseEventsAction(response));
    } catch (error){
        yield put(errorEventsAction(error));
    }
    }

    export function* workAnniversaryWishesRequest(action) {
        try {
            const response = yield call(EventService.shared.workAnniversaryWishesRequest, action.data);
            yield put(responseWorkAnniversaryWishes(response));
        } catch (error){
            yield put(errorWorkAnniversaryWishes(error));
        }
        } 

    export function* birthdayWishesRequest(action) {
     try {
                const response = yield call(EventService.shared.birthdayWishesRequest, action.data);
                yield put(responseBirthdayWishes(response));
            } catch (error){
                yield put(errorBirthdayWishes(error));
            }
            } 

            export function* eventsNotificationsListRequest(action) {
                try {
                    const response = yield call(EventService.shared.eventsNotificationsListRequest, action.data);
                    yield put(responseEventsNotificationsAction(response));
                } catch (error){
                    yield put(errorEventsNotificationsAction(error));
                }
                }

    export function* eventsWatcherSage() {
        yield takeLatest(EVENT_ACTION.REQUEST_EVENTS_LIST, eventsListRequest);
        yield takeLatest(EVENT_ACTION.REQUEST_WORK_ANNIVERSARY_WISHES, workAnniversaryWishesRequest);
        yield takeLatest(EVENT_ACTION.REQUEST_BIRTHDAY_WISHES, birthdayWishesRequest);
        yield takeLatest(EVENT_ACTION.REQUEST_EVENTS_NOTIFICATIONS_LIST, eventsNotificationsListRequest);
    }